export enum FacilityUserDepartment {
  NotApplicable = 0,
  InformationTechnology = 1,
  Accounting = 2,
  Owner = 3,
  Normal = 4,
}

export const facilityUserDepartmentOptions = [
  { label: "Not Applicable", value: FacilityUserDepartment.NotApplicable },
  { label: "Information Technology (IT)", value: FacilityUserDepartment.InformationTechnology },
  { label: "Accounting", value: FacilityUserDepartment.Accounting },
  { label: "Owner", value: FacilityUserDepartment.Owner },
  { label: "Normal", value: FacilityUserDepartment.Normal },
];

export const getFacilityUserDepartmentLabel = (value: number | null | undefined): string => {
  const option = facilityUserDepartmentOptions.find((o) => o.value === value);
  return option?.label ?? "Not Applicable";
};
